// src/Banner.tsx
import { AppBar, Toolbar, Typography, Container, Box, Tabs, Tab } from '@mui/material';

interface BannerProps {
  gameType: 'endgame' | 'opening';
  setGameType: React.Dispatch<React.SetStateAction<'endgame' | 'opening'>>;
}

const Banner: React.FC<BannerProps> = ({ gameType, setGameType }) => {
  return (
    <AppBar position="static" color="transparent" elevation={0} sx={{ borderBottom: '1px solid #e0e0e0' }}>
      <Container maxWidth="lg">
        <Toolbar disableGutters sx={{ justifyContent: 'space-between' }}>

          {/* Logo / Title Area */}
          <Box display="flex" alignItems="center">
            {/* Desktop Logo */}
            <Box
              component="img"
              src={process.env.PUBLIC_URL + '/logo192.png'}
              alt="Logo"
              sx={{
                display: { xs: 'none', md: 'block' },
                height: 40,
                width: 40,
                mr: 2,
                borderRadius: 1 // Optional: adds slight rounding if it's a square
              }}
            />
            <Typography
              variant="h6"
              noWrap
              component="a"
              href="/"
              sx={{
                mr: 2,
                display: { xs: 'none', md: 'flex' },
                fontFamily: 'monospace',
                fontWeight: 700,
                letterSpacing: '.3rem',
                color: '#375643', // TODO: Update to match logo color
                textDecoration: 'none',
              }}
            >
              CHESSFINISH
            </Typography>

            {/* Mobile Logo */}
            <Box
              component="img"
              src={process.env.PUBLIC_URL + '/logo192.png'}
              alt="Logo"
              sx={{
                display: { xs: 'block', md: 'none' },
                height: 32,
                width: 32,
                mr: 1.5,
                borderRadius: 1
              }}
            />
            <Typography
              variant="h6"
              noWrap
              component="a"
              href=""
              sx={{
                mr: 2,
                display: { xs: 'flex', md: 'none' },
                fontFamily: 'monospace',
                fontWeight: 700,
                letterSpacing: '.1rem',
                color: '#375643', // TODO: Update to match logo color
                textDecoration: 'none',
                fontSize: { xs: '1rem', sm: '1.2rem' },
              }}
            >
              CHESSFINISH
            </Typography>
          </Box>

          {/* Game Type Toggle (Center/Right) */}
          <Box>
            <Tabs
              value={gameType}
              onChange={(_, val) => setGameType(val)}
              textColor="primary"
              indicatorColor="primary"
              aria-label="game type selection"
              sx={{ minHeight: 40 }}
            >
              <Tab label="Endgames" value="endgame" sx={{ fontWeight: 'bold', textTransform: 'none', minHeight: 40, fontSize: { xs: '0.8rem', md: '1rem' }, px: { xs: 1, md: 2 } }} />
              <Tab
                label={
                  <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', lineHeight: 1.2 }}>
                    <span>Openings</span>
                    <Typography variant="caption" sx={{ fontSize: '0.6rem', textTransform: 'none', opacity: 0.7 }}>
                      (in progress)
                    </Typography>
                  </Box>
                }
                value="opening"
                disabled
                sx={{ textTransform: 'none', minHeight: 40, fontSize: { xs: '0.8rem', md: '1rem' }, px: { xs: 1, md: 2 } }}
              />
            </Tabs>
          </Box>

        </Toolbar>
      </Container>
    </AppBar>
  );
};

export default Banner;
